import cn from 'classnames';
import React from 'react';
import { MdCheckBoxOutlineBlank, MdOutlineCheckBox } from 'react-icons/md';
import './PortalInputCheckbox.css';

type InputCheckboxProps = { size?: number } & Omit<React.ComponentPropsWithoutRef<'input'>, 'type'>;

export const PortalInputCheckbox = ({ size = 36, className = '', ...props }: InputCheckboxProps) => {
    return (
        <div className={cn(`relative rounded flex w-full h-full items-center py-[10.5px]`, className)}>
            <input
                className={cn('cursor-pointer custom-checkbox')}
                style={{
                    height: size,
                    width: size
                }}
                type="checkbox"
                {...props}
            />

            {props.checked ? (
                <MdOutlineCheckBox className={cn('text-brand-primary', className)} />
            ) : (
                <MdCheckBoxOutlineBlank className={cn('text-brand-primary', className)} />
            )}
        </div>
    );
};
